$(document).ready(function () {
    window.dataLayer = window.dataLayer || [];
    var HeaderDataLayer = $('input[name="dataLayer"]').val();
    var members_id = '';
    if (HeaderDataLayer) {
        HeaderDataLayer = JSON.parse(HeaderDataLayer);
        if (HeaderDataLayer.user_properties) {
            if (HeaderDataLayer.user_properties.customer_birthday) {
                HeaderDataLayer.user_properties.customer_birthday = CryptoJS.SHA256(HeaderDataLayer.user_properties.customer_birthday).toString(CryptoJS.enc.Hex);
            }
            if (HeaderDataLayer.user_properties.customer_id) {
                members_id = HeaderDataLayer.user_properties.customer_id;
                HeaderDataLayer.user_properties.customer_id = CryptoJS.SHA256(HeaderDataLayer.user_properties.customer_id).toString(CryptoJS.enc.Hex);
            }
        } 
        if (HeaderDataLayer.user_id) {
            HeaderDataLayer.user_id = CryptoJS.SHA256(HeaderDataLayer.user_id).toString(CryptoJS.enc.Hex);
        }
        dataLayer.push(HeaderDataLayer);
    }

    var topDataLayer = $('input[name="topDataLayer"]').val();
    if(topDataLayer) {
        var topDataLayer = JSON.parse(topDataLayer);
        topDataLayer.HashedEmail = topDataLayer.HashedEmail ? CryptoJS.SHA256(topDataLayer.HashedEmail).toString(CryptoJS.enc.Hex) : '';
        dataLayer.push(topDataLayer);
    }

    if($("main").hasClass('page_product_detail')) {
        var productsData = $('input[name="productDataLayer"]').val();
        if (productsData) {
            productsData = JSON.parse(productsData);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
                event: 'view_item',
                ecommerce: {
                    value: productsData.ecommerceValue,
                    currency: 'JPY',
                    items: productsData.items
                },
                members_id: members_id
            });
        }        
        var personalDataTopPage = $('input[name="personalData"]').val();
        if (personalDataTopPage) {
            personalDataTopPage = JSON.parse(personalDataTopPage);
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'personaldata',
                members_id: personalDataTopPage.members_id,
                email: personalDataTopPage.email || '',
                phone: personalDataTopPage.phone || '',
                zipcode: personalDataTopPage.zipcode || ''
            });
        }
    }

    var isConfirmSection = $("section").hasClass('order-confirmation-section');
    var isPdpSection = $("main").hasClass('page_product_detail');
    var isCartSection = $("main").hasClass('cart-page');
    var isCheckout = $("form").is('#place-order-form');
    //Check if current page is signup complete page. (Login-MemberStep3)
    var isSignupComplete = $("form").hasClass("register_member3__form");

    if(!isConfirmSection && !isPdpSection && !isCartSection && !isCheckout && !isSignupComplete){
        dataLayer.push({
            user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '',
        });
    }

    if($("section").hasClass('order-confirmation-section')) {
        // dataLayer2
        dataLayer.push({ ecommerce: null });// Clear the previous 
        var order2 = $('input[name="orderInformation2"]').val();
        var personalData = $('input[name="orderInformation3"]').val();
        order2 = JSON.parse(order2);
        personalData = JSON.parse(personalData);

        order2.user_id = HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : '';
        order2.members_id = members_id;

        dataLayer.push(order2);
        dataLayer.push(personalData);
    }

    //User enter entry_complete page when not logged in, HeaderDataLayer is empty.
    //Has to get memberID from input[name="memberID"]
    if (isSignupComplete) {
        const urlParams = new URLSearchParams(window.location.search);
        var members_id = $('input[name="memberID"]').val();
        var user_id = members_id ? CryptoJS.SHA256(members_id).toString(CryptoJS.enc.Hex) : '';
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            user_id: user_id,
            event: 'signup_complete',
            members_id: members_id,
            utm_source: urlParams.get('utm_source') || '',
            utm_medium: urlParams.get('utm_medium') || '',
            utm_campaign: urlParams.get('utm_campaign') || ''
        });
    }

    // personaldata datalayer for page top / PLP
    var piplinePageTop = ['Default-Start', 'Home-Index', 'Home-Men', 'Home-Women'];
    var detectPipline = $('div.page').data('action');
    var personalDataTopPage = $('input[name="personalData"]').val();
    if (piplinePageTop.includes(detectPipline) && personalDataTopPage) {
        personalDataTopPage = JSON.parse(personalDataTopPage);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'personaldata',
            members_id: personalDataTopPage.members_id,
            email: personalDataTopPage.email || '',
            phone: personalDataTopPage.phone || '',
            zipcode: personalDataTopPage.zipcode || ''
        });
    }

});
